import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { AddConsultationCalendarDialogComponent } from "./add-consultation-calendar-dialog.component";

@NgModule({
  declarations: [AddConsultationCalendarDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [AddConsultationCalendarDialogComponent],
})
export class AddConsultationCalendarDialogModule {}
